<nb-card class="card">
	<nb-card-header class="card-header-title">
		<h6> 
			<ng-template [ngIf]="flag === flagEnum.BASE" [ngIfElse]="categoryTitle">
				{{ ((editType === actionEnum.EDIT) ? 'HELP_PAGE.MANAGE_BASE' : 'HELP_PAGE.ADD_BASE') | translate }} 
			</ng-template>
			<ng-template #categoryTitle>
				{{ ((editType === actionEnum.EDIT) ? 'HELP_PAGE.MANAGE_CATEGORY' : 'HELP_PAGE.ADD_CATEGORY') | translate }} 
			</ng-template>
		</h6>
		<nb-icon icon="close-outline" (click)="closeDialog()"></nb-icon>
	</nb-card-header>
	<nb-card-body class="card-body">
		<form [formGroup]="form" (ngSubmit)="submit()" #knowledgeBaseForm="ngForm">
			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label id="language" class="label">{{ 
							'HELP_PAGE.LANGUAGE' | translate 
						}}</label>
						<ngx-language-selector
							[placeholder]="'FORM.PLACEHOLDERS.SELECT' | translate"
							[clearable]="false"
							[addTag]="false"
							[selectedLanguageCode]="language"
							template="ng-select"
							selectBy="object"
							(selectedLanguageEvent)="selectedLanguage($event)"
						></ngx-language-selector>
					</div>
				</div>
				<div class="col-12">
					<div class="form-group mt-2 mb-2">
						<nb-toggle
							status="primary"
							labelPosition="start"
							[checked]="privacy"
							(checkedChange)="togglePrivacy($event)"
						>
							<span> {{ 'HELP_PAGE.PUBLISH_STATUS' | translate }} </span>
						</nb-toggle>
					</div>
				</div>
				<div class="col-12">
					<div class="form-group">
						<label id="icon" class="label">{{ 
							'HELP_PAGE.CHOSE_ICON' | translate 
						}}</label>
						<nb-select
							[placeholder]="'FORM.PLACEHOLDERS.SELECT_ICON' | translate"
							formControlName="icon"
							fullWidth
							id="icon"
							[status]="
								isInvalidControl('icon') ? 'danger' : 'basic'
							"
						>
							<nb-select-label *ngIf="icon">
								<nb-icon
									[ngStyle]="{ color: 'black' }"
									class="mr-1"
									[icon]="icon.value"
								></nb-icon
								>{{ icon.label }}
							</nb-select-label>
							<nb-option *ngFor="let icon of icons" [value]="icon">
								<nb-icon class="mr-1" [icon]="icon.value"></nb-icon>
								{{ icon.label }}
							</nb-option>
						</nb-select>
					</div>
				</div>
				<div class="col-12">
					<div class="form-group">
						<label id="color" class="label">{{ 
							'HELP_PAGE.COLOR' | translate 
						}}</label>
						<input
							formControlName="color"
							[placeholder]="'HELP_PAGE.COLOR' | translate"
							[colorPicker]="color"
							[value]="color"
							(colorPickerChange)="selectedColor($event)"
							[style.background]="color"
							fullWidth
							nbInput
							id="color"
						/>
					</div>
				</div>
				<div class="col-12">
					<div class="form-group">
						<label id="name" class="label">{{ 
							((flag === 'base') ? 'HELP_PAGE.NAME_OF_THE_BASE' : 'HELP_PAGE.NAME_CATEGORY') | translate 
						}}
						</label>
						<input
							formControlName="name"
							[placeholder]="
								((flag === 'base') ? 'HELP_PAGE.NAME_OF_THE_BASE' : 'HELP_PAGE.NAME_CATEGORY') | translate
							"
							type="text"
							size="24"
							maxlength="18"
							fullWidth
							nbInput
							id="name"
							[status]="
								isInvalidControl('name') ? 'danger' : 'basic'
							"
						/>
					</div>
				</div>
				<div class="col-12">
					<div class="form-group">
						<label id="description" class="label">
							{{ 'HELP_PAGE.DESCRIPTION' | translate }}
						</label>
						<input
							formControlName="description"
							[placeholder]="'HELP_PAGE.DESCRIPTION' | translate"
							type="text"
							size="30"
							maxlength="26"
							fullWidth
							nbInput
							id="description"
						/>
					</div>
				</div>
			</div>
		</form>
	</nb-card-body>
	<nb-card-footer class="text-right">
		<button
			status="success"
			(click)="knowledgeBaseForm.ngSubmit.emit()"
			[disabled]="form.invalid"
			nbButton
		>
			{{ 'BUTTONS.SAVE' | translate }}
		</button>
	</nb-card-footer>
</nb-card>
